// src/PrivateRoute.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, adminOnly = false }) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const uStr = localStorage.getItem("user") || sessionStorage.getItem("user");
  const user = uStr ? JSON.parse(uStr) : null;

  if (!token) return <Navigate to="/login" />;

  if (adminOnly && user?.role !== "admin") {
    return <Navigate to="/" />;
  }

  return element;
};

PrivateRoute.propTypes = {
  element: PropTypes.node.isRequired,
  adminOnly: PropTypes.bool,
};

export default PrivateRoute;
